const tooltipV2RootKey = Symbol("tooltipV2");
const tooltipV2ContentKey = Symbol("tooltipV2Content");
const TOOLTIP_V2_OPEN = "tooltip_v2.open";

export { TOOLTIP_V2_OPEN, tooltipV2ContentKey, tooltipV2RootKey };
//# sourceMappingURL=constants.mjs.map
